import { useRequest } from "hooks/useRequest";
import { useClientIdentificator } from "hooks/useClientIdentificator";

export const useAccountRequester = () => {
	const request = useRequest("Account");
	const { client, environment } = useClientIdentificator();

	return {
		validateAccount: async (email: string): Promise<boolean> => {
			return request
				.POST(
					"validate",
					{ email },
					{
						"X-Tenant": client,
						...(environment
							? { "X-Environment": environment }
							: {}),
					},
				)
				.then((response: any) => response.data as boolean);
		},
	};
};
